import { curry, is, map, reject, reduce, toPairs, equals, isNil } from 'ramda';
import { isPlainObject } from 'ramda-adjunct';
import { camel, snake } from 'to-case';

type anyObject = {
  [key: string]: object;
};

export const transformObjectKeys = curry((transformer: (key) => any, obj: anyObject) => {
  if (is(Array, obj)) {
    return map((val) => transformObjectKeys(transformer, val), obj);
  }

  if (isPlainObject(obj)) {
    return reduce(
      (acc, [key, value]) => ({
        ...acc,
        [transformer(key)]: transformObjectKeys(transformer, value),
      }),
      {},
      toPairs(obj),
    );
  }

  return obj;
});

export const keysToCamelCase = transformObjectKeys(camel);
export const keysToSnakeCase = transformObjectKeys(snake);

export const removeUndefinedValues = reject<{}>(equals(undefined));
export const removeNilValues = reject<{}>(isNil);
